import { EntFarmOwner } from "./farmOwners";
import { EntAnimalBreed } from "./handBooks/animalBreed";
import { EntAnimalCount } from "./handBooks/animalCount";
import { EntArea } from "./handBooks/area";
import { EntBreedingFarmStatus } from "./handBooks/breedingFarmStatus";

export class EntBreedingFarm {
  id: number = 0;
  nameRu: string = '';
  nameKy: string = '';
  farmsStatusId: number | undefined = undefined;
  farmsStatus: EntBreedingFarmStatus | null = null;
  animals: EntAnimalCount[] | null = null;
  animalBreedIds: EntAnimalBreed[] | null = null;
  animalBreeds: EntAnimalBreed[] | null = null;
  areaId: number  | undefined = undefined;
  area: EntArea  | null = null;
  ownerId: number  | undefined = undefined;
  owner: EntFarmOwner  | null = null;
  address: string = '';
  longitude: number | undefined = undefined;
  latitude: number | undefined = undefined;
}
